import React from "react";
import { CheckboxContainer, HiddenCheckbox, StyledCheckbox, CheckmarkIcon } from "./FormStyles";

const CustomCheckbox = ({ className, checked, checkedColor, uncheckedColor, checkmarkColor, ...props }) => (
  <CheckboxContainer className={className}>
    <HiddenCheckbox checked={checked} {...props} />
    <StyledCheckbox checked={checked} checkedColor={checkedColor} uncheckedColor={uncheckedColor}>
      {checked && (
        <CheckmarkIcon viewBox="0 0 24 24" checkmarkColor={checkmarkColor}>
          <polyline points="20 6 9 17 4 12" />
        </CheckmarkIcon>
      )}
    </StyledCheckbox>
  </CheckboxContainer>
);

export default CustomCheckbox;
